import { IApp } from '@/types/nuxt'
import { VacancyMapQueryDto } from '@tokyojob/core'
import { errors, LogType, QueryStringEntity, getVacancyMapStore } from '@tokyojob/frontend-core'
import { getAppStore } from '~/store/app.store'

export default class FetchMapVacanciesUseCase implements BaseUsecase {
  app: IApp
  constructor(app: IApp) {
    this.app = app
  }

  async execute(dto: VacancyMapQueryDto, options: QueryStringEntity): Promise<boolean> {
    const { baseGateway, logService } = this.app
    const vacancyMap = getVacancyMapStore()
    const appStore = getAppStore()
    // unset location because we don't need this data to the map
    options.location = ''
    try {
      const data = await baseGateway.vacancy.GetVacancyMap(dto, options)
      vacancyMap.save(data)
      return true
    } catch (error) {
      await logService.handle({ type: LogType.Error, error: error as Error })
      appStore.setErrors(errors(error))
      return false
    }
  }
}
